var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Board',{attrs:{"title":"监理日志","icon":"/images/data-center-screen/boards/icon-supervision-logs.svg","hint":"浏览全部","sub-window":"supervisionLogs"},on:{"sub-window":function($event){return _vm.$emit('sub-window', $event)}}},[_c('CalendarChart',{attrs:{"list":_vm.history,"field":"supervisionLogsPending"},on:{"select-month":_vm.updateMonth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }